import React from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { showDialog } from "../../../Redux/actions/dialogActions";
import DataTable from "../../../Components/Tables/DataTables";
import ActionButtons from "../../../Components/UI/Buttons/ActionButtons";
import { getAllSummaryApi } from "../../../API/request";
import useApi from "../../../Hooks/UseApi";
import translator from "../../../shared/translator";
import RemoveSummary from "./RemoveSummary";

const UnAnswered = () => {
    const dispatch = useDispatch();
    const queryString = window.location;
    const url = new URL(queryString);
    const page = url.searchParams.get("page");
    const history = useHistory();
    const [summaries, setSummaries] = React.useState([]);
    const [search, setSearch] = React.useState("");
    const [data, loading, callApi] = useApi();
    React.useEffect(() => {
        fetchData();
    }, [page]);
    const fetchData = async () => {
        let data = await callApi(getAllSummaryApi, { status: "IN_PROGRESS", page, search });
        setSummaries(data);
    }
    const submitSearch = (e) => {
        e.preventDefault();
        fetchData();
    }
    const HeaderData = [
        { field: "number", title: "ردیف" },
        { field: "name", title: "نام" },
        { field: "surname", title: "نام خانوادگی" },
        { field: "mobile", title: "شماره موبایل" },
        { field: "reqStatus", title: "وضعیت" },
        { field: "payed_at", title: "تاریخ پرداخت", type: "dateTime" },
        { field: "summary_date", title: "تاریخ ارجاع", type: "dateTime" },
        { field: "action", title: "مشاهده و پاسخ" },
    ];

    const deleteModal = (item) => {
        dispatch(showDialog(<RemoveSummary id={item.id} remove={(id) => removeSummary(id)} />, false, "sm"));
    };

    const removeSummary = (id) => {
        let newData = summaries.data.filter((summ) => summ.id != id);
        setSummaries({ ...summaries, data: newData });
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <form onSubmit={submitSearch}>
                    <TextField
                        placeholder="جستجو"
                        variant="outlined"
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <Button variant="contained" type="submit" color="primary" style={{marginRight: 10}} >ثبت</Button>
                </form>
            </Grid>
            <Grid item xs={12}>
                <DataTable
                    title={`لیست درخواست ها (${summaries?.meta?.total ?? 0})`}
                    headData={HeaderData}
                    data={summaries.data ?? []}
                    action={(item) => (
                        <ActionButtons
                            functions={{
                                show: () => history.push(`/dashboard/reponses/${item.request_id}`),
                                remove: () => deleteModal(item)
                            }}
                            show
                            remove
                        />
                    )}
                    number={(item, key) => (page - 1) * 10 + key}
                    reqStatus={(item) => translator(item.status)}
                    lastPage={summaries.meta?.last_page ?? 1}
                    currentPage={page}
                    route="/dashboard/reponses/unAnswred"
                />
            </Grid>
        </Grid>
    );
};

export default UnAnswered;
